export default "__VITE_ASSET__xFtoyi7N__"